import notify from "devextreme/ui/notify";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { DataGrid } from "../../../../../components";
import { DataGridButtonProps } from "../../../../../components/data-grid/types";
import { getApiParams } from "../../../../../redux/auth";
import { BodyType, createRequest } from "../../../../../redux/base/request";
import { ApiResponse, verfiyResponse } from "../../../../../redux/base/types/saga";
import { getLocalized } from "../../../../../redux/localization";
import { adminProducts, productUrl } from "../../../../../services/urls";
import { Product } from "../../../../products/types";






const AccountProductPage = () => {
  const localize = useSelector(getLocalized);
  const history = useHistory();
  const { token, lang } = useSelector(getApiParams);
  const { Id }: { Id: string } = useParams();

  const columns = [
    {
      dataField: "Code",
      caption: localize.getString("code"),
    },
    {
      dataField: "Name",
      caption: localize.getString("name"),
    },
    {
      dataField: "ProductTypeName",
      caption: localize.getString("producttypename"),
    },

    {
      dataField: "Approved",
      caption: localize.getString("approved"),
    },
    {
      dataField: "ApproverUser",
      caption: localize.getString("approveruser"),
    },
  ];
  const buttons: DataGridButtonProps[] = [
    {
      hint: "info",
      icon: "info",
      onClick: function (e: any) {
        history.push(`/product-details/${e.row.data.Id}`);
      },
    },
    {
      hint: "remove",
      icon: "trash",
      onClick: async function (e: any) {
        const response: ApiResponse<Product> = await createRequest({
          method: "DELETE",
          url: "/api/product/" + e.row.data.Id,
          bodyType: BodyType.formdata,
          token,
          body: {},
          lang,
        });
        if (verfiyResponse(response)) {
          notify(response.Message, "success")
        }
      }
    }
  ];

  return (
    <DataGrid
      buttons={buttons}
      title={"Hesap Ürünleri"}
      gridButtons={[
        {
          buttonText: "Ekle",
          icon: "add",
          type: "success",
          onclick: function () {
            history.push(`/add-account-product/${Id}`);
          },
        }
      ]}
      getByIdUrl={productUrl}
      url={adminProducts + "/" + Id}
      columns={columns || []}
      refObject={{}}

    // details={{
    //   width: "35%",
    //   height: "62%",
    //   getByIdUrl: "api/AppUser",
    //   title: "Kullanıcı Detayları",
    //   component: DetailUserForm,
    // }}
    // edit={{
    //   width: "35%",
    //   height: "62%",
    //   editUrl: userUrl,
    //   title: "Kullanıcı Düzenle",
    //   component: EditUserForm,
    //   validationGroup: "editUserFormValidation",
    // }}
    // create={{
    //   lookup: {
    //     lookupUrl: ""
    //   },
    //   width: "75%",
    //   height: "62%",
    //   createUrl: addProductUrl,
    //   title: "Ürün Ekle",
    //   component: CreateAccountProductForm,
    //   validationGroup: "createAccountProductFormValidation",
    // }}

    />
  );
};
export default AccountProductPage;
